import { Dialog } from '@avanta/shared/components/ui/Dialog';
import { ONE_DAY_IN_SECONDS } from '@avanta/shared/constants/appointments';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useTranslation } from 'react-i18next';
import { type Appointment } from 'types/appointments';
import { isMoreThanSecondsBefore } from 'utils/date';
import { useCancelAppointment } from './useCancelAppointment';

export const CancelAppointmentDialog = ({
  appointment,
}: {
  appointment: Appointment;
}): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);
  const { mutate: cancelAppointment } = useCancelAppointment(appointment.id);

  const handleCancelAccount = async (): Promise<void> => {
    if (appointment?.id) {
      cancelAppointment({
        psychologistId: appointment.psychologistId,
        appointmentId: appointment.id,
        patientId: appointment.patientId,
      });
      //TODO add cancel Event
    }
  };

  const isDescriptionNoRefund = !isMoreThanSecondsBefore(appointment.dateTime, ONE_DAY_IN_SECONDS);

  const description = isDescriptionNoRefund
    ? 'CancelAppointment.Dialog.body.noRefund'
    : 'CancelAppointment.Dialog.body.refund';

  return (
    <Dialog
      title={t('CancelAppointment.Dialog.heading')}
      description={t(description)}
      secondaryAction={{
        label: t('CancelAppointment.Dialog.cancel'),
        variant: 'terciary',
      }}
      primaryAction={{
        label: t('CancelAppointment.Dialog.confirm'),
        action: handleCancelAccount,
        variant: 'terciary',
        className: 'text-red-500 hover:border-red-600 hover:bg-red-100',
      }}
      open
      hideClose
    />
  );
};
